module.exports = __webpack_public_path__ + "img/gray-caret-down.6c26510e.svg";